<template>
    <table class="table table-sm table-hover table-thead-bordered table-nowrap table-align-middle">
        <thead class="thead-light sticky-header">
            <tr>
                <th>&nbsp;</th>
                <th class="text-primary">{{ $t('Collected') }}</th>
                <th class="text-primary">{{ $t('Period') }}</th>
                <th class="text-primary">{{ $t('Comp %') }}</th>
                <th class="text-primary">{{ $t('Best 30') }}</th>
                <th class="text-primary">{{ $t('Avg Use Time') }}</th>
                <th class="text-primary">{{ $t('Avg Pres') }}</th>
                <th class="text-primary">{{ $t('Avg P95') }}</th>
                <th class="text-primary">{{ $t('AHI') }}</th>
                <th class="text-primary">{{ $t('SNI') }}</th>
                <th class="text-primary">{{ $t('High Leak') }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="report in sortedReports" :key="report.id">
                <td>
                    <input
                        v-model="activeReportsIds"
                        :value="report.id"
                        type="checkbox"
                        class="form-check-input" />
                </td>
                <td>{{ report.collected }}</td>
                <td>{{ report.icode_period }}</td>
                <td>{{ (report.compliant_days / report.icode_period * 100).toFixed(2) }}%</td>
                <td>{{ (report.best30 / 30).toFixed(2) }}</td>
                <td>{{ minutesToFormattedString(report.minutes) }}</td>
                <td>{{ report.pressure }}</td>
                <td>{{ report.p95 }}</td>
                <td>{{ report.ahi }}</td>
                <td>{{ report.sni }}</td>
                <td>{{ report.leak }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script lang="ts" setup>
import { computed, type PropType } from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";
import moment from "moment";
import { type ReportType } from "@/vue/types/report";
import useDates from "@/vue/composables/useDates";

const activeReportsIds = defineModel<number[]>();
const props = defineProps({
    reports: {
        type: Array as PropType<ReportType[]>,
        default: () => [],
    },
});

const { minutesToFormattedString } = useDates();

const sortedReports = computed(() => [...props.reports].sort((a, b) => moment(b.collected).diff(a.collected)));
</script>
